import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CloudUpload, RefreshCw, WifiOff } from "lucide-react";
import { subscribeQueue, syncNow } from "../lib/offlineSync";
import { useOnline } from "./SafeGuardArchive";

// Compare solo quando serve: senza connessione, registrazioni in attesa di invio, conflitti o rifiuti.
export default function OfflineStatusBar() {
  const online = useOnline();
  const [q, setQ] = useState(null);
  useEffect(() => subscribeQueue(setQ), []);
  const pending = q?.pending || 0;
  const problems = (q?.conflicts || 0) + (q?.rejected || 0);
  if (online && !pending && !problems) return null;
  const tone = problems ? "bg-red-50 text-red-800 border-red-200" : !online ? "bg-amber-50 text-amber-900 border-amber-200" : "bg-blue-50 text-blue-900 border-blue-200";
  return (
    <div className={`border-b px-3 py-2 text-sm sm:px-6 ${tone}`} role="status" data-testid="offline-status-bar">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center gap-x-3 gap-y-1">
        {!online ? <WifiOff className="h-4 w-4 shrink-0" /> : problems ? <AlertTriangle className="h-4 w-4 shrink-0" /> : <CloudUpload className="h-4 w-4 shrink-0" />}
        <span className="min-w-0 flex-1">
          {!online && <strong>Senza connessione. </strong>}
          {!online && "Le registrazioni vengono salvate su questo dispositivo e inviate appena torna la rete. "}
          {pending > 0 && <span data-testid="offline-pending-count">{pending === 1 ? "1 registrazione in attesa di invio" : `${pending} registrazioni in attesa di invio`}. </span>}
          {problems > 0 && <span>{problems === 1 ? "1 registrazione da verificare" : `${problems} registrazioni da verificare`}. </span>}
        </span>
        {online && pending > 0 && (
          <button type="button" onClick={() => syncNow()} disabled={q?.syncing} className="inline-flex min-h-[36px] items-center gap-1.5 font-medium underline-offset-2 hover:underline disabled:opacity-60" data-testid="offline-sync-now">
            <RefreshCw className={`h-4 w-4 ${q?.syncing ? "animate-spin" : ""}`} />{q?.syncing ? "Invio in corso…" : "Invia ora"}
          </button>
        )}
        <Link to="/app/ispezione#dispositivo" className="inline-flex min-h-[36px] items-center font-medium underline">Dettagli</Link>
      </div>
    </div>
  );
}
